var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLogin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 36.364,
    viewBox: "0 0 200 36.364",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.042,
    y1: 0.208,
    x2: 0.897,
    y2: 0.754,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dcef4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#29abe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#0c7dc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#184478"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#626366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269,
    stopColor: "#a8abad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419,
    stopColor: "#d8d9db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491,
    stopColor: "#ebebec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#dadcdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#c6c8ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#abadaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#8a8b8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963,
    stopColor: "#626365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286",
    transform: "translate(-24 -38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LC-02",
    transform: "translate(24 38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M184.191,168.7l-9.1-5.25L166,168.7l.171,4.161a11.1,11.1,0,0,0,3.035,7.286c1.707,1.707,4.235,3.261,5.89,3.261s4.184-1.555,5.89-3.261a11.1,11.1,0,0,0,3.035-7.286Zm-4.306,10.192c-1.388,1.388-3.444,2.652-4.79,2.652s-3.4-1.264-4.79-2.652a9.026,9.026,0,0,1-2.468-5.925l-.139-3.384,7.4-4.269,7.4,4.269-.139,3.384A9.023,9.023,0,0,1,179.885,178.892Z",
    transform: "translate(-158.973 -154.931)",
    fill: "#1f4175"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M113.613,72.079V88.764L99.12,97.2v-5.14l10.041-5.869V74.49ZM96,92.063,85.822,86.194V74.5l-4.452-2.41V88.764L96,97.2Zm-9.3-19.85,10.794-6.232,10.785,6.289,4.452-2.571L97.491,60.84l-15.246,8.8Z",
    transform: "translate(-81.37 -60.84)",
    fill: "#1f4175"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(8.725 10.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M189.066,199.478a9.026,9.026,0,0,1-2.468-5.925l-.139-3.384,7.4-4.269,7.4,4.269-.139,3.384a9.026,9.026,0,0,1-2.468,5.925c-1.388,1.388-3.444,2.652-4.79,2.652S190.454,200.867,189.066,199.478Z",
    transform: "translate(-186.46 -185.9)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M198.14,245.858l6.365-4.338-7.072,3.114-7.072-3.114,6.365,4.338.707,7.275Z",
    transform: "translate(-181.311 -226.519)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LC-03",
    transform: "translate(72.484 51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M47.43,258.1V247.837h2.049V258.1a1.23,1.23,0,0,0,1.231,1.234H62.582v2.05H50.711A3.274,3.274,0,0,1,47.43,258.1Zm18-10.261h2.049v13.541H65.427ZM69.752,258.1v-6.98a3.27,3.27,0,0,1,3.281-3.281H85.8v2.03H73.032a1.247,1.247,0,0,0-1.234,1.251v6.98a1.231,1.231,0,0,0,1.234,1.234h9.936A1.231,1.231,0,0,0,84.2,258.1v-2.465H76.067v-2.049H86.233V258.1a3.265,3.265,0,0,1-3.261,3.281H73.036A3.27,3.27,0,0,1,69.752,258.1Zm33.208-2.465h-12.4v5.746H88.508V247.837h2.049v5.746h12.4v-5.746h2.03v13.541h-2.03Zm11.534-5.765h-7.226v-2.03h16.481v2.03h-7.206v11.511h-2.049Zm11.531,8.231v-6.98a3.27,3.27,0,0,1,3.28-3.281H142.07v2.03H129.305a1.246,1.246,0,0,0-1.231,1.251v6.98a1.23,1.23,0,0,0,1.231,1.234H142.07v2.05H129.305A3.274,3.274,0,0,1,126.025,258.1Zm18.321,0v-6.98a3.27,3.27,0,0,1,3.281-3.281h9.936a3.265,3.265,0,0,1,3.261,3.281v6.98a3.265,3.265,0,0,1-3.261,3.281h-9.936A3.27,3.27,0,0,1,144.346,258.1Zm2.049-6.98v6.98a1.231,1.231,0,0,0,1.234,1.234h9.936A1.231,1.231,0,0,0,158.8,258.1v-6.98a1.245,1.245,0,0,0-1.234-1.251h-9.936A1.245,1.245,0,0,0,146.4,251.117Zm31.158,5.746a1.232,1.232,0,0,0-1.231-1.234h-10.28v-2.049h10.28a1.23,1.23,0,0,0,1.231-1.234v-1.234a1.244,1.244,0,0,0-1.231-1.251H165.152v11.511H163.1V247.83h13.22a3.265,3.265,0,0,1,3.261,3.28v1.234a3.272,3.272,0,0,1-.891,2.256,3.278,3.278,0,0,1,.891,2.256v4.515h-2.03v-4.508Zm4.309,1.234v-6.98a3.27,3.27,0,0,1,3.281-3.281h12.765v2.03H185.142a1.247,1.247,0,0,0-1.234,1.251v2.465h14v2.049h-14V258.1a1.231,1.231,0,0,0,1.234,1.234h12.765v2.05H185.142A3.274,3.274,0,0,1,181.862,258.1Z",
    transform: "translate(-46.392 -247.057)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M44.26,255.734V245.473h2.049v10.261a1.23,1.23,0,0,0,1.231,1.234H59.412v2.049H47.54A3.275,3.275,0,0,1,44.26,255.734Zm18-10.261H64.31v13.541H62.26Zm4.325,10.261v-6.98a3.27,3.27,0,0,1,3.281-3.281H82.631v2.03H69.866a1.247,1.247,0,0,0-1.234,1.251v6.98a1.231,1.231,0,0,0,1.234,1.234H79.8a1.231,1.231,0,0,0,1.234-1.234v-2.465H72.9v-2.05H83.066v4.515a3.265,3.265,0,0,1-3.261,3.281H69.869A3.27,3.27,0,0,1,66.585,255.734Zm33.208-2.465h-12.4v5.746H85.342V245.473h2.049v5.746h12.4v-5.746h2.03v13.541h-2.03Zm11.531-5.765H104.1v-2.03h16.481v2.03h-7.206v11.511h-2.049Zm11.534,8.231v-6.98a3.27,3.27,0,0,1,3.28-3.281H138.9v2.03H126.138a1.246,1.246,0,0,0-1.231,1.251v6.98a1.23,1.23,0,0,0,1.231,1.234H138.9v2.049H126.138A3.275,3.275,0,0,1,122.858,255.734Zm18.321,0v-6.98a3.27,3.27,0,0,1,3.281-3.281H154.4a3.265,3.265,0,0,1,3.261,3.281v6.98a3.265,3.265,0,0,1-3.261,3.281h-9.936A3.27,3.27,0,0,1,141.179,255.734Zm2.046-6.977v6.98a1.231,1.231,0,0,0,1.234,1.234H154.4a1.231,1.231,0,0,0,1.234-1.234v-6.98a1.245,1.245,0,0,0-1.234-1.251h-9.936A1.243,1.243,0,0,0,143.225,248.757Zm31.161,5.746a1.232,1.232,0,0,0-1.231-1.234h-10.28v-2.05h10.28a1.23,1.23,0,0,0,1.231-1.234v-1.234a1.244,1.244,0,0,0-1.231-1.251H161.985v11.511h-2.049V245.47h13.22a3.265,3.265,0,0,1,3.261,3.28v1.234a3.272,3.272,0,0,1-.891,2.256,3.278,3.278,0,0,1,.891,2.256v4.515h-2.03Zm4.305,1.231v-6.98a3.27,3.27,0,0,1,3.281-3.281h12.765v2.03H181.972a1.247,1.247,0,0,0-1.234,1.251v2.465h14v2.05h-14v2.465a1.231,1.231,0,0,0,1.234,1.234h12.765v2.049H181.972A3.275,3.275,0,0,1,178.692,255.734Z",
    transform: "translate(-44.26 -245.47)",
    fill: "#818181"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLogin);
export default __webpack_public_path__ + "static/media/logo__login.2b81c2e63b194de21c337b814d038d30.svg";
export { ForwardRef as ReactComponent };